module.exports = __webpack_public_path__ + "assets/b27a5fc8c456c70d76e59d79032107d6.mp3";